import styled from 'styled-components'

export const CatalogItemDetailsDescriptionsStyled = styled.div`
  && {
    dl {
      grid-template-columns: ${(props) =>
          props.theme.typography.pxToRem(167)} minmax(0, 1fr);
      column-gap: ${(props) => props.theme.space.small};
      row-gap: ${(props) => props.theme.space.small};
    }

    dl > label,
    dl > div {
      padding: 0;
      font-size: ${(props) => props.theme.typography.pxToRem(14)};
      line-height: ${(props) => props.theme.typography.pxToRem(24)};
    }

    dl > label {
      font-weight: ${(props) => props.theme.fontWeights.normal};
      color: ${(props) => props.theme.colors.text.primary};
    }
  }
`
